import { Box, css, ListItemText, styled, Typography } from "@mui/material";

export function ListItemTextWithHotkey({ children, hotkey }: { children: React.ReactNode; hotkey: string }) {
    return (
        <ListItemText>
            <ItemContent>
                {children}
                <Typography color="grey" ml={2}>
                    {hotkey}
                </Typography>
            </ItemContent>
        </ListItemText>
    );
}

const ItemContent = styled(Box)(
    ({ theme }) => css`
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: ${theme.spacing(1)};
    `,
);
